import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/Home/Home'

Vue.use(Router)

export const redirectList = [
  '/login', '/register'
]

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('../views/Main/Main'),
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: Home,
          name: 'Home',
          meta: {
            isTabBar: true,
            title: 'home.title'
          }
        },
        {
          path: '/currency',
          component: () => import('../views/Currency/Currency'),
          name: 'Currency',
          meta: {
            isTabBar: true,
            title: 'currency.title'
          }
        },
        {
          path: '/trade',
          component: () => import('../views/Trade/Trade'),
          name: 'Trade',
          meta: {
            isTabBar: true,
            title: 'trade.title'
          }
        },
        {
          path: '/fund',
          component: () => import('../views/Fund/Fund'),
          name: 'Fund',
          meta: {
            isTabBar: true,
            title: 'fund.title'
          }
        },
        {
          path: '/finance',
          component: () => import('../views/Finance/Finance'),
          name: 'Finance',
          meta: {
            isTabBar: true,
            title: 'finance.title'
          }
        },
        {
          path: '/all-finance',
          component: () => import('../views/AllFinance/AllFinance.vue'),
          name: 'AllFinance',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'allFinance.title'
          }
        },
        {
          path: '/buy-finance',
          component: () => import('../views/BuyFinance/BuyFinance.vue'),
          name: 'BuyFinance',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'buyFinance.title'
          }
        },
        {
          path: '/finance-orders',
          component: () => import('../views/FinanceOrders/FinanceOrders.vue'),
          name: 'FinanceOrders',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'financeOrders.title'
          }
        },
        {
          path: '/finance-order-bills',
          component: () => import('../views/FinanceOrderBills/FinanceOrderBills.vue'),
          name: 'FinanceOrderBills',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'financeOrderBills.title'
          }
        },
        {
          path: '/user-center',
          component: () => import('../views/UserCenter/UserCenter'),
          name: 'UserCenter',
          meta: {
            isTabBar: true,
            title: 'userCenter.title'
          }
        },
        {
          path: '/contract-trade',
          component: () => import('../views/ContractTrade/ContractTrade'),
          name: 'ContractTrade',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: '合约交易'
          }
        },
        {
          path: '/user-bills',
          component: () => import('../views/UserBills/UserBills'),
          name: 'UserBills',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'userBills.title'
          }
        },
        {
          path: '/settings',
          component: () => import('../views/Settings/Settings'),
          name: 'Settings',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'settings.title'
          }
        },
        {
          path: '/edit-login-password',
          component: () => import('../views/EditLoginPassword/EditLoginPassword'),
          name: 'EditLoginPassword',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'editLoginPassword.title'
          }
        },
        {
          path: '/bind-fund-password',
          component: () => import('../views/BindFundPassword/BindFundPassword'),
          name: 'BindFundPassword',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'bindFundPassword.title'
          }
        },
        {
          path: '/bind-google-validator',
          component: () => import('../views/BindGoogleValidator/BindGoogleValidator'),
          name: 'BindGoogleValidator',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'bindGoogleValidator.title'
          }
        },
        {
          path: '/edit-fund-password',
          component: () => import('../views/EditFundPassword/EditFundPassword'),
          name: 'EditFundPassword',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'editFundPassword.title'
          }
        },
        {
          path: '/receive-ways',
          component: () => import('../views/ReceiveWays/ReceiveWays'),
          name: 'ReceiveWays',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'receiveWays.title'
          }
        },
        {
          path: '/zsk-account',
          component: () => import('../views/ZskAccount/ZskAccount'),
          name: 'ZskAccount',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'zskAccount.title'
          }
        },
        {
          path: '/add-zsk-account',
          component: () => import('../views/AddZskAccount/AddZskAccount'),
          name: 'AddZskAccount',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'addZskAccount.title'
          }
        },
        {
          path: '/add-bank-card',
          component: () => import('../views/AddBankCard/AddBankCard'),
          name: 'AddBankCard',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'addBankCard.title'
          }
        },
        {
          path: '/wallet-address',
          component: () => import('../views/WalletAddress/WalletAddress'),
          name: 'WalletAddress',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'walletAddress.title'
          }
        },
        {
          path: '/add-wallet-address',
          component: () => import('../views/AddWalletAddress/AddWalletAddress'),
          name: 'AddWalletAddress',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'addWalletAddress.title'
          }
        },
        {
          path: '/help',
          component: () => import('../views/Help/Help'),
          name: 'Help',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'help.title'
          }
        },
        {
          path: '/help-detail/:helpIndex',
          component: () => import('../views/HelpDetail/HelpDetail'),
          name: 'HelpDetail',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'helpDetail.title'
          }
        },
        {
          path: '/share',
          component: () => import('../views/Share/Share'),
          name: 'Share',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'share.title'
          }
        },
        {
          path: '/recharge',
          component: () => import('../views/Recharge/Recharge'),
          name: 'Recharge',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'recharge.title'
          }
        },
        {
          path: '/withdraw',
          component: () => import('../views/Withdraw/Withdraw'),
          name: 'Withdraw',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'withdraw.title'
          }
        },
        {
          path: '/recharge-order',
          component: () => import('../views/RechargeOrder/RechargeOrder'),
          name: 'RechargeOrder',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'rechargeOrder.title'
          }
        },
        {
          path: '/withdraw-order',
          component: () => import('../views/WithdrawOrder/WithdrawOrder'),
          name: 'WithdrawOrder',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'withdrawOrder.title'
          }
        },
        {
          path: '/timing-trade-order',
          component: () => import('../views/TimingTradeOrder/TimingTradeOrder'),
          name: 'TimingTradeOrder',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'timingTradeOrder.title'
          }
        },
        {
          path: '/spot-holding',
          component: () => import('../views/SpotHolding/SpotHolding'),
          name: 'SpotHolding',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: '期货持仓'
          }
        },
        {
          path: '/contract-trade-order',
          component: () => import('../views/ContractTradeOrder/ContractTradeOrder'),
          name: 'ContractTradeOrder',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'contractTradeOrder.title'
          }
        },
        {
          path: '/my-team',
          component: () => import('../views/MyTeam/MyTeam'),
          name: 'MyTeam',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'myTeam.title'
          }
        },
        {
          path: '/add-user',
          component: () => import('../views/AddUser/AddUser'),
          name: 'AddUser',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'addUser.title'
          }
        },
        {
          path: '/user-report',
          component: () => import('../views/UserReport/UserReport'),
          name: 'UserReport',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'userReport.title'
          }
        },
        {
          path: '/user-report-day',
          component: () => import('../views/UserReportDay/UserReportDay'),
          name: 'UserReportDay',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'userReportDay.title'
          }
        },
        {
          path: '/team-report',
          component: () => import('../views/TeamReport/TeamReport'),
          name: 'TeamReport',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'teamReport.title'
          }
        },
        {
          path: '/team-report-day',
          component: () => import('../views/TeamReportDay/TeamReportDay'),
          name: 'TeamReportDay',
          meta: {
            isTabBar: false,
            isHeaderArea: true,
            title: 'teamReportDay.title'
          }
        },
        {
          path: '/add-to-home',
          component: () => import('../views/AddToHome/AddToHome'),
          name: 'AddToHome',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'addToHome.title'
          }
        },
        {
          path: '/my-message',
          component: () => import('../views/MyMessage/MyMessage'),
          name: 'MyMessage',
          meta: {
            isTabBar: false,
            isHeaderArea: false,
            title: 'myMessage.title'
          }
        }
      ]
    },
    {
      path: '/login',
      component: () => import('../views/Login/Login')
    },
    {
      path: '/register',
      component: () => import('../views/Register/Register')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js